import { ChangeEvent } from 'react'
import styles from '../../AdminTools.module.css'

interface HeaderAlignedInputProps {
  label: string
  inputValue: string
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
  maxLength?: number
  type?: string
}

export const HeaderAlignedInput = ({
  label,
  inputValue,
  handleChange,
  maxLength,
  type,
}: HeaderAlignedInputProps) => {
  return (
    <div className={styles.headerAlignedRow}>
      <div className={styles.headerAlignedLabel}>{label}</div>
      <input
        maxLength={maxLength ?? 10}
        type={type ?? 'text'}
        value={inputValue}
        onChange={handleChange}
        className={type === 'email' ? styles.emailInput : styles.textInput}
      />
    </div>
  )
}
